import { SERVER_URL } from "../../utils/constants";
import HttpRequest from "../../utils/HttpRequest";


export const createService = async (data: any,) => {
  return await HttpRequest.post(`${SERVER_URL}/order/create`, data);
};

export const getAllService = async (query: string) => {
  return HttpRequest.get(`${SERVER_URL}/order${query}`);
};

export const getOneService = async (id: string) => {
  return HttpRequest.get(`${SERVER_URL}/order/one/${id}`);
};
